import { render, staticRenderFns } from "./iatBlockIntro.vue?vue&type=template&id=a72c8c4a"
import script from "./iatBlockIntro.vue?vue&type=script&lang=js"
export * from "./iatBlockIntro.vue?vue&type=script&lang=js"
import style0 from "./iatBlockIntro.vue?vue&type=style&index=0&id=a72c8c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports